import React from "react";

import "./Badge.scss";
import { useIntl } from "react-intl";
import { getBadgeTranslations } from "helpers/translationHelpers";

export type BadgeType = "primary" | "secondary" | "tertiary" | "warning" | "danger";

type BadgeProps = {
  type: BadgeType;
  label: string;
  style?: React.CSSProperties;
};

function Badge(props: BadgeProps) {
  const { type, label, style } = props;
  const intl = useIntl();

  return (
    <div style={{ lineHeight: "12px", ...(style && style) }} className={`custom-badge d-flex align-items-center ${type}`}>
      {getBadgeTranslations(label, intl) ?? label}
    </div>
  );
}

export default Badge;

Badge.defaultProps = {
  style: undefined,
};
